export enum roles {
    blog_admin = "blog-admin", // Access to blog modules (feeds and site feeds)
    
    blog_feed_deploy = "blog-feed-deploy", // Access to deploy module for feeds
    
    blog_post_create = "blog-post-create", // Access to create post
    blog_post_update = "blog-post-update", // Access to update post
    blog_post_remove = "blog-post-remove", // Access to remove post
    blog_post_deploy = "blog-post-deploy" // Access to deploy post
}